export class toothPosRuleDto {
    StdCode: string;
    ToothPosLimited: string[];
    NeedToCheckToothPos: boolean;
    NeedToCheckQuantity: boolean;
    NeedToRemark: boolean;
    EndDate: Date|string;
}